import React from 'react';
import { useSelectableCardStyles } from 'components/UI/V2/Forms/SelectableCard/SelectableCard.styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

export interface SelectableCardProps {
    label: string;
    description: string;
    icon?: React.ReactNode;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}

export const SelectableCard: React.FC<SelectableCardProps> = props => {
    const classes = useSelectableCardStyles(props);

    return (
        <div
            className={classes.root}
            onClick={() => props.onChange?.(!props.checked)}
        >
            <div className={classes.card}>
                <div className={classes.iconContainer}>{props.icon}</div>

                <div>
                    <label className={classes.label}>{props.label}</label>
                    <p className={classes.description}>{props.description}</p>
                </div>

                <div className={classes.radioContainer}>
                    <div className={classes.radio}>
                        <FontAwesomeIcon icon={faCircleCheck} />
                    </div>
                </div>
            </div>
        </div>
    );
};
